import { render, staticRenderFns } from "./PaginaRedirecionamento.vue?vue&type=template&id=2965103a"
import script from "./PaginaRedirecionamento.vue?vue&type=script&lang=js"
export * from "./PaginaRedirecionamento.vue?vue&type=script&lang=js"
import style0 from "./PaginaRedirecionamento.vue?vue&type=style&index=0&id=2965103a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports